import script from "./AppSidebarr.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSidebarr.vue?vue&type=script&setup=true&lang=js"

import "./AppSidebarr.vue?vue&type=style&index=0&id=87f23a1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87f23a1c"]])

export default __exports__